import { DialogBody } from '@chakra-ui/react';
import { useState } from 'react';

function ZoomableImage({ selectedImage }) {
    const [transformOrigin, setTransformOrigin] = useState('center center');

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;
        setTransformOrigin(`${x}% ${y}%`);
        e.preventDefault();
    };

    return (
        <DialogBody sx={{ flex: 1, p: 0, bg: 'gray.50' }}>
        {selectedImage ? (
            <div
            style={{
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            >
            <img
                src={selectedImage?.url}
                alt={selectedImage?.name}
                style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain',
                display: 'block',
                margin: '0 auto',
                transition: 'transform 0.3s ease, transform-origin 0.1s ease',
                transformOrigin,
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(2)')}
                onMouseMove={handleMouseMove}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            />
            </div>
        ) : null}
        </DialogBody>
    );
}

export default ZoomableImage;
